import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _get from 'babel-runtime/helpers/get';
import _inherits from 'babel-runtime/helpers/inherits';
import { UpModule } from './upmodule';
import Result from '../../_interface/result';
export var LogicEngine = function (_UpModule) {
    _inherits(LogicEngine, _UpModule);

    function LogicEngine(plugin) {
        _classCallCheck(this, LogicEngine);

        var _this = _possibleConstructorReturn(this, (LogicEngine.__proto__ || Object.getPrototypeOf(LogicEngine)).call(this, plugin));

        _this.deviceChangeListenerList = new Map();
        _this.onLogicEnginePluginChangeListener = function (mac, baseInfo, attrs, cautions) {
            var onDeviceChanged = _this.deviceChangeListenerList.get(mac);
            if (onDeviceChanged) {
                onDeviceChanged(mac, baseInfo, attrs, cautions);
            }
        };
        return _this;
    }

    _createClass(LogicEngine, [{
        key: 'attachPromise',
        value: function attachPromise(mac, deviceChangeListener) {
            var self = this;
            document.container.upLogModule.printParameters('attachPromise', mac);
            var resultPromise = new Promise(function (resolve, reject) {
                self.rejectIfNoPlugin(reject);
                self.plugin.attach(mac, self.onLogicEnginePluginChangeListener, function (result) {
                    if (result.isSuccessful()) {
                        document.container.upLogModule.printSucceedResult('attachPromise', result);
                        resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570attach(' + mac + ', ' + deviceChangeListener + ')\u6210\u529F', result.retData));
                    }
                    document.container.upLogModule.printFailResult('attachPromise', result);
                    reject(new Result('000001', '\u8C03\u7528\u51FD\u6570attach(' + mac + ', ' + deviceChangeListener + ')\u5931\u8D25'));
                });
            });
            this.deviceChangeListenerList.set(mac, deviceChangeListener);
            return resultPromise;
        }
    }, {
        key: 'attachLazy',
        value: function attachLazy(mac, deviceChangeListener) {
            var self = this;
            document.container.upLogModule.printParameters('attachLazy', mac);
            var resultPromise = new Promise(function (resolve, reject) {
                self.rejectIfNoPlugin(reject);
                self.plugin.attachLazy(mac, self.onLogicEnginePluginChangeListener, function (result) {
                    if (result.isSuccessful()) {
                        document.container.upLogModule.printSucceedResult('attachLazy', result);
                        resolve(new Result('000000', '\u8C03\u7528\u51FD\u6570attachLazy(' + mac + ', ' + deviceChangeListener + ')\u6210\u529F', result.retData));
                    }
                    document.container.upLogModule.printFailResult('attachLazy', result);
                    reject(new Result('000001', '\u8C03\u7528\u51FD\u6570attachLazy(' + mac + ', ' + deviceChangeListener + ')\u5931\u8D25'));
                });
            });
            this.deviceChangeListenerList.set(mac, deviceChangeListener);
            return resultPromise;
        }
    }, {
        key: 'calculateAllPromise',
        value: function calculateAllPromise(mac, commands) {
            var clearFlag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            return this.generatePromiseByPluginFunctionWithParams('calculateAll', mac, commands, clearFlag);
        }
    }, {
        key: 'calculatePromise',
        value: function calculatePromise(mac, name, value) {
            var clearFlag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            return this.generatePromiseByPluginFunctionWithParams('calculate', mac, name, value, clearFlag);
        }
    }, {
        key: 'detachPromise',
        value: function detachPromise(mac) {
            return this.generatePromiseByPluginFunctionWithParams('detach', mac);
        }
    }, {
        key: 'getAttributeByNamePromise',
        value: function getAttributeByNamePromise(mac, name) {
            return this.generatePromiseByPluginFunctionWithParams('getAttributeByName', mac, name);
        }
    }, {
        key: 'getAttributeListPromise',
        value: function getAttributeListPromise(mac) {
            return this.generatePromiseByPluginFunctionWithParams('getAttributeList', mac);
        }
    }, {
        key: 'getBaseInfoPromise',
        value: function getBaseInfoPromise(mac) {
            return this.generatePromiseByPluginFunctionWithParams('getBaseInfo', mac);
        }
    }, {
        key: 'getCautionsPromise',
        value: function getCautionsPromise(mac) {
            return this.generatePromiseByPluginFunctionWithParams('getCautionList', mac);
        }
    }, {
        key: 'getInitialAttributeListPromise',
        value: function getInitialAttributeListPromise(mac) {
            return this.generatePromiseByPluginFunctionWithParams('getInitialAttributeList', mac);
        }
    }, {
        key: 'operatePromise',
        value: function operatePromise(mac, commands) {
            return this.generatePromiseByPluginFunctionWithParams('operate', mac, commands);
        }
    }, {
        key: 'startDeviceBusinessFunction',
        value: function startDeviceBusinessFunction(mac, name, clean) {
            return this.generatePromiseByPluginFunctionWithParams('startDeviceBusinessFunction', mac, name, clean);
        }
    }, {
        key: 'modifyBusinessFunction',
        value: function modifyBusinessFunction(mac, name, value) {
            return this.generatePromiseByPluginFunctionWithParams('modifyBusinessFunction', mac, name, value);
        }
    }, {
        key: 'getBusinessFunctionCachedAttributes',
        value: function getBusinessFunctionCachedAttributes(mac) {
            return this.generatePromiseByPluginFunctionWithParams('getBusinessFunctionCachedAttributes', mac);
        }
    }, {
        key: 'getDeviceBusinessFunctionList',
        value: function getDeviceBusinessFunctionList(mac) {
            return this.generatePromiseByPluginFunctionWithParams('getDeviceBusinessFunctionList', mac);
        }
    }, {
        key: 'executeBusinessFunction',
        value: function executeBusinessFunction(mac) {
            return this.generatePromiseByPluginFunctionWithParams('executeBusinessFunction', mac);
        }
    }, {
        key: 'refreshAttributesPromise',
        value: function refreshAttributesPromise(mac) {
            return this.generatePromiseByPluginFunctionWithParams('refreshAttributes', mac);
        }
    }, {
        key: 'getErrorCodeAndText',
        value: function getErrorCodeAndText(_code) {
            var info = '';
            var code = '';
            switch (_code) {
                case '99999':
                    code = '000001';
                    info = '未知错误';
                    break;
                case '90000':
                    code = '000001';
                    info = '操作失败';
                    break;
                case '90001':
                    code = '120001';
                    info = '操作无效';
                    break;
                case '90002':
                    code = '120002';
                    info = '操作超时';
                    break;
                case '90003':
                    code = '000002';
                    info = '非法参数错误';
                    break;
                case '90004':
                    code = '120003';
                    info = 'JSON转换错误';
                    break;
                case '90005':
                case '130001':
                    code = '120004';
                    info = '逻辑引擎不存在';
                    break;
                case '90006':
                    code = '120007';
                    info = '逻辑引擎未准备好';
                    break;
                case '90100':
                case '90101':
                case '130002':
                    code = '120005';
                    info = '逻辑对象属性错误';
                    break;
                default:
                    return _get(LogicEngine.prototype.__proto__ || Object.getPrototypeOf(LogicEngine.prototype), 'getErrorCodeAndText', this).call(this, _code);
            }
            return { code: code, msg: info };
        }
    }]);

    return LogicEngine;
}(UpModule);